import { render } from "./ParcProfile.vue?vue&type=template&id=606c9713"
import script from "./ParcProfile.vue?vue&type=script&lang=js"
export * from "./ParcProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__